import React from 'react';
import { BsTelephoneFill, BsGeoAltFill } from 'react-icons/bs';
import ContactForm from '../components/ContactForm';
import logoMCF from '../assets/images/logo-mcf.png';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1 className="contact-title">Nous Contacter</h1>
        </div>
      </section>
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Contactez Top Conduite</h2>
              <p className="contact-description">
                Pour toute question ou inscription, n'hésitez pas à nous contacter. 
                Notre équipe est à votre disposition pour vous accompagner dans votre projet de formation à la conduite.
              </p>
              <div className="contact-details">
                <a href="tel:0952655019" className="contact-detail-item">
                  <BsTelephoneFill className="contact-detail-icon" />
                  <div>
                    <h3>Téléphone</h3>
                    <p>09 52 65 50 19</p>
                  </div>
                </a>
                <a href="https://maps.google.com/?q=19+Av.+Franklin+Roosevelt,+77290+Mitry-Mory" target="_blank" rel="noopener noreferrer" className="contact-detail-item">
                  <BsGeoAltFill className="contact-detail-icon" />
                  <div>
                    <h3>Adresse</h3>
                    <p>19 Av. Franklin Roosevelt<br />77290 Mitry-Mory</p>
                  </div>
                </a>
                <div className="contact-detail-item">
                  <span className="contact-detail-icon">🕒</span>
                  <div>
                    <h3>Horaires</h3>
                    <p>Dim - Lun : Fermé<br />Mar - Ven : 10:00–12:00, 14:00–18:00<br />Sam : 10:00–12:00</p>
                  </div>
                </div>
              </div>

              <div className="payment-info">
                <div className="payment-item">
                  <div className="payment-3x-badge" aria-hidden="true">
                    <span className="payment-3x-value">3×</span>
                  </div>
                  <div className="payment-content">
                    <h3 className="payment-title">Paiement en 3 fois</h3>
                    <p className="payment-description">Sans frais</p>
                  </div>
                </div>
                <div className="payment-item" style={{ display: 'none' }}>
                  <div className="payment-logo-wrapper">
                    <img src={logoMCF} alt="Mon Compte Formation" className="payment-logo" />
                  </div>
                  <div className="payment-content">
                    <h3 className="payment-title">Financement CPF</h3>
                    <p className="payment-description">Possible</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-form-section contact-form-section--sidebar">
              <ContactForm isSidebar={true} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
